import { render } from "./CreateTaskNote.vue?vue&type=template&id=62c8e8e2"
import script from "./CreateTaskNote.vue?vue&type=script&lang=js"
export * from "./CreateTaskNote.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__